<template>
  <div class="eol-container-box">
    <div class="search-all-box">
      <a-form-model layout="inline" ref="ruleForm" :model="form">
        <a-form-model-item prop="class_name">
          <a-input v-model="form.class_name" class="search-input" placeholder="请输入班级名称"></a-input>
        </a-form-model-item>

        <a-form-model-item>
          <a-button class="search-btn" type="primary" @click="onSearch">搜索</a-button>
          <a-button class="reset-btn" @click="resetForm">重置</a-button>
        </a-form-model-item>
      </a-form-model>
      <div class="right-option-box">
        <a-button class="option-btn" type="primary" @click="handleModalVisible('showAddModal',true, null)">添加班级</a-button>
      </div>
    </div>
    <div class="table-all-box">
      <a-table :columns="columns" :data-source="tableData" rowKey="id" size="small" :pagination="false">

        <template slot="classname" slot-scope="text,record">
          <div class="erweima-icon" @click="getQrcode(record)"></div>{{text}}
        </template>
        <template slot="action" slot-scope="text,record">
          <a-button type="link" @click="getQrcode(record)">班级邀请码</a-button>
          <a-button type="link" @click="handleModalVisible('showEditModal',true, record)">编辑班级</a-button>
          <a-button type="link" @click="handleStudent(record)">班级学生</a-button>
          <a-button type="link" @click="handleModalVisible('showDeleteModal',true, record)">删除</a-button>
        </template>
      </a-table>

      <a-pagination class="school-pagination" v-model="page" :total="totalNum" @change="pageChange" show-less-items />

    </div>
    <!-- 班级邀请码 -->
    <CommonModal v-model="showIntervalModal" title="班级邀请码" confirmText="下载邀请码" @confirm="handleInviteConfirm" width="580px" :showCancel="false">
      <div v-if="classDetail" :class="['invite-container',inviteDownload?'download':'']">
        <div class="class-activity">{{ classDetail.activity_name }}</div>
        <div class="class-info">
          <div class="class-name">班级名称：{{ classDetail.name }}</div>
          <div class="class-teacher">负责教师：{{classDetail.teacher_names}}</div>
        </div>
        <div class="invite-content">
          <div class="invite-code">
            <div class="invite-left">
              <div class="invite-label">班级邀请码：</div>
              <div class="invite-number" ref="copyTarget">{{classDetail.code}}</div>
            </div>
            <div class="invite-copy" @click="handleCopy()">复制邀请码</div>
          </div>
          <div class="invite-qrcode">
            <img :src="imgUrl">
          </div>
        </div>

      </div>

    </CommonModal>

    <CommonModal v-model="showDeleteModal" title="删除班级" confirmText="确定" @confirm="handleDeleteConfirm">
      <div class="delete-modal">
        确定删除班级吗？
      </div>
    </CommonModal>

    <CommonModal v-model="showEditModal" title="编辑班级" confirmText="确定" @confirm="handleEditConfirm">
      <div class="search-all-box edit-modal">
        <a-form>
          <a-form-item label="班级名称：">
            <a-input class="search-input" placeholder="请输入班级名称" v-model="edit_name"></a-input>
          </a-form-item>
        </a-form>
      </div>
    </CommonModal>

    <CommonModal v-model="showAddModal" title="添加班级" confirmText="确定" @confirm="handleAddConfirm">
      <div class="search-all-box edit-modal">
        <a-form>
          <a-form-item label="班级名称：">
            <a-input class="search-input" placeholder="请输入班级名称" v-model="add_name"></a-input>
          </a-form-item>
        </a-form>
      </div>
    </CommonModal>

    <div v-if="showIntervalModal && classDetail" class="user-download-box" ref="captureArea">
      <div class="bg-line"></div>
      <div class="activity">{{ classDetail.activity_name }}</div>
      <div class="class">班级名称：{{ classDetail.name }}</div>
      <div class="teacher">负责教师：{{classDetail.teacher_names}}</div>
      <div class="invite-qrcode">
        <img :src="imgUrl">
      </div>
      <div class="code-line">班级邀请码：{{classDetail.code}}</div>
    </div>

  </div>
</template>
<script>
import html2canvas from "html2canvas";
import CommonModal from "../../../components/CommonModal"
import { mapActions } from "vuex";
import QRCode from "qrcode";
import services from "../../../assets/js/services";

export default {
  name: "activityClass",
  components: {
    CommonModal
  },
  data () {
    return {
      school_code: localStorage.getItem("schoolCode"),
      showIntervalModal: false,
      showDeleteModal: false,
      showEditModal: false,
      showAddModal: false,
      inviteDownload: false, // 是否正在下载邀请码
      page: 1,
      size: 10,
      totalNum: 0,
      tableData: [],
      form: {
        class_name: "",
      },
      edit_name: "",// 编辑的班级名称
      add_name: "", // 添加的班级名称
      columns: [
        {
          title: "班级名称",
          dataIndex: "name",
          scopedSlots: { customRender: 'classname' },
        },
        {
          title: "学生人数",
          dataIndex: "member_num",
        },
        {
          title: "负责教师",
          dataIndex: "teacher_names",
        },
        {
          title: "创建时间",
          dataIndex: "created_at",
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: '400px'
        },
      ],
      activity_id: '', //当前活动id
      imgUrl: "", //二维码图片地址
      classItem: null, //当前操作的班级对象
      classDetail: null, // 当前班级的详情
    };
  },
  mounted () {
    this.activity_id = this.$route.query.id
    this.getTableList()
  },
  methods: {
    ...mapActions(["getSchoolActivityClasses", "addSchoolActivityClasses", "editSchoolActivityClasses", "getSchoolActivityClassesInfo"]),
    // 获取班级列表 表格数据
    getTableList () {
      let params = {
        page: this.page,
        size: this.size,
        activity_id: this.activity_id,
        name: this.form.class_name,
      };
      this.getSchoolActivityClasses(params).then((res) => {
        if (res.code == "0000" && res.data) {
          this.tableData = res.data.items;
          this.totalNum = res.data.total;
          // console.log(res.data)
        }
      });
    },
    // 搜索按钮
    onSearch () {
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },
    // 分页点击事件
    pageChange (val) {
      this.page = val;
      this.total = 0;
      this.getTableList();
    },
    // 搜索重置按钮
    resetForm () {
      this.$refs.ruleForm.resetFields();
      this.onSearch()
    },
    // 跳转班级学生页面
    handleStudent (item) {
      this.classItem = item
      this.$router.push(`/${this.school_code}/school/activity/class/student?id=${this.activity_id}&cid=${item.id}`)
    },
    // 获取班级二维码
    getQrcode (item) {
      this.classItem = item
      this.getSchoolActivityClassesInfo({ id: item.id, data: { activity_id: this.activity_id } }).then(res => {
        if (res.code == '0000' && res.data) {
          this.classDetail = res.data
          QRCode.toDataURL(`${services.HOST}/${this.school_code}/student/joinclass?code=${res.data.code}`, (err, url) => {
            if (err) console.error(err);
            console.log(url);
            this.imgUrl = url
            console.log(this.imgUrl);
          });
        }
        this.handleModalVisible('showIntervalModal', true, null)
      })

    },
    // 下载邀请码
    handleInviteConfirm () {
      let that = this
      let timer
      that.inviteDownload = true
      if (timer) clearTimeout(timer)
      timer = setTimeout(function () {
        const element = that.$refs.captureArea;
        html2canvas(element).then((canvas) => {
          const image = canvas.toDataURL("image/png");
          const link = document.createElement("a");
          link.href = image;
          link.download = `【${that.classDetail.activity_name}】【${that.classDetail.name}】【邀请码】`;
          link.click();
          that.inviteDownload = false
        });
      }, 300)
    },
    // 复制邀请码
    handleCopy () {
      const text = this.$refs.copyTarget.innerText; // 获取文本内容
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text)
        this.$message.success("复制成功")
      } else {
        // 兼容性处理 (execCommand 方式)
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.$message.success("复制成功")
      }
    },
    // 弹窗显示隐藏
    handleModalVisible (key, val, item) {
      this[key] = val
      if (key == 'showAddModal') {
        this.add_name = ''
      }
      if (item) {
        this.classItem = item
        if (key == 'showEditModal') {
          this.edit_name = item.name
        }
      }
    },
    // 删除弹窗 - 确认事件
    handleDeleteConfirm () {
      this.classEditAndDelete(2, { id: this.classItem.id, data: { activity_id: this.activity_id, _method: 'delete' } })
      this.handleModalVisible("showDeleteModal", false, null)
    },
    // 班级添加和删除方法
    classEditAndDelete (type, params) {
      this.editSchoolActivityClasses(params).then(res => {
        if (res.code == "0000") {
          this.$message.success(`${type == 1 ? '编辑' : '删除'}成功`)
          this.resetForm()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 编辑班级弹窗 - 确认事件
    handleEditConfirm () {
      let that = this
      if (this.edit_name) {
        if (this.edit_name.length > 100) {
          this.$message.error("班级名称不能超过100个字")
        } else {
          that.classEditAndDelete(1, { id: this.classItem.id, data: { name: this.edit_name, activity_id: this.activity_id, _method: 'put' } })
          this.handleModalVisible("showEditModal", false, null)
        }
      } else {
        this.$message.error("请输入班级名称")
      }
    },
    // 添加班级弹窗 - 确认事件
    handleAddConfirm () {
      let that = this
      if (this.add_name) {
        if (this.add_name.length > 100) {
          this.$message.error("班级名称不能超过100个字")
        } else {
          this.addSchoolActivityClasses({ name: this.add_name, activity_id: this.activity_id }).then(res => {
            if (res.code == "0000") {
              that.$message.success(`添加成功`)
              that.resetForm()
            } else {
              that.$message.error(res.message)
            }
          })
          this.handleModalVisible("showAddModal", false, null)
        }
      } else {
        this.$message.error("请输入班级名称")
      }
    }
  },
};
</script>

<style lang="less" scoped>
.invite-container {
    position: relative;
    .class-activity {
        font-weight: bold;
        font-size: 16px;
        color: #373536;
        text-align: center;
    }
    .class-info {
        display: flex;
        justify-content: center;
        font-size: 14px;
        color: #3c3c3e;
        padding-top: 9px;
        div:not(:last-child) {
            margin-right: 20px;
        }
    }
    .invite-content {
        padding-top: 21px;
        .invite-code {
            display: flex;
            justify-content: center;
            height: 32px;
            .invite-left {
                width: 300px;
                background: #ffffff;
                border-radius: 16px 0 0 16px;
                border: 1px solid #dcdfe6;
                display: flex;
                align-items: center;
                padding: 0 16px;
                .invite-label,
                .invite-number {
                    font-size: 14px;
                    color: #a82822;
                }
            }
            .invite-copy {
                width: 101px;
                height: 32px;
                background: #b84b3c;
                border-radius: 0px 16px 16px 0px;
                text-align: center;
                line-height: 32px;
                cursor: pointer;
                font-size: 14px;
                color: #ffffff;
            }
        }
        .invite-qrcode {
            text-align: center;
            padding-top: 24px;
            img {
                width: 161px;
                height: 161px;
            }
        }
    }
    &.download {
        .invite-copy {
            display: none;
        }
        .invite-left {
            justify-content: center;
            text-align: center;
            border: none !important;
        }
    }
}
.edit-modal {
    /deep/ .ant-form-item {
        display: flex;
        margin-right: 0;
        .ant-form-item-label {
            color: #373536;
        }
        .ant-input {
            width: 281px;
        }
    }
}
.delete-modal {
    font-weight: bold;
    font-size: 16px;
    color: #373536;
    text-align: center;
}
.erweima-icon {
    width: 13px;
    height: 13px;
    cursor: pointer;
    background: url('../../../assets/image/school/common/erweima.png') no-repeat
        center/cover;
    vertical-align: -1px;
    display: inline-block;
    margin-right: 6px;
}
// 下载的样式
.user-download-box {
    position: fixed;
    top: 0;
    right: -800px;
    width: 700px;
    background: #ffffff;
    padding: 0 0 45px;
    box-sizing: border-box;
    text-align: center;
    .bg-line {
        position: absolute;
        z-index: 1;
        top: 0;
        width: 100%;
        height: 80px;
        background: linear-gradient(0deg, #ffffff 0%, #ffcbc9 100%);
        opacity: 0.8;
    }
    .activity {
        position: relative;
        z-index: 10;
        width: 90%;
        margin: 0 auto;
        text-align: center;
        font-weight: bold;
        font-size: 24px;
        color: #373536;
        padding: 64px 0 44px;
    }
    .class {
        width: 90%;
        margin: 0 auto;
        text-align: center;
        font-size: 24px;
        font-weight: normal;
        margin-bottom: 20px;
        color: #3c3c3e;
    }
    .teacher {
        width: 90%;
        margin: 0 auto;
        text-align: center;
        font-size: 16px;
        color: #3c3c3e;
        margin-bottom: 20px;
        line-height: 32px;
    }
    .code-line {
        margin: 20px auto 0;
        width: 368px;
        height: 54px;
        line-height: 54px;
        font-size: 24px;
        color: #a82822;
        background: #fff8f7;
        text-align: center;
    }
}
</style>
